//import moment from 'moment'

export default {

    namespaced:true,

    state: {

        statuses: { 
            draft:{title:'Skitse'}, 
            sent:{title:'Afsendt'}, 
            accepted:{title:'Accepteret'}, 
            archived:{title:'Arkiverede'},
        },

        types: {
            //range_estimation: { title: 'Pris-overslag', },
            estimates: {
                title: 'Tilbud/timepris',
            },    
            fixed_prices: {
                title: 'Tilbud/fastpris',
            },    
        },

    },// state

    getters: {


        // basic crud
        getAll: (state,getters,rootState,rootGetters) => {
            return rootGetters.getAll('specs')
            if( !rootGetters.firebase_arrays.specs ) return []
            return rootGetters.firebase_arrays.specs
        },
        
        // basic crud
        //getOne: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.key === key ) return item },
        getOne: (state,getters,rootState,rootGetters) => (key) =>  { return rootGetters.getOne('spec',key) },

        // will find first spec for a project. projects should only have the one spec
        getByProjectKey: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.project_key === key ) return item },

        
        // changed, so it will just find the one project spec - since projects no longer should have more than one spec
        getProjectAcceptedSpec: (state,getters,rootState,rootGetters) => (project_key) => 
        {
            var list = rootState.firebase.specs
            for( var spec_key in list ) {
                if(spec_key == '.key') continue // why, vuexfire?
                var spec = list[spec_key]
                spec['.key'] = spec_key
                if( spec.archived ) continue
                if( spec.project_key == project_key ) return spec
            }
        },


        getHours: (state,getters,rootState,rootGetters) => (spec) => 
        {
            var total_hrs = 0
            
            for( var i in spec.taskcats )  {                
                var taskcat = spec.taskcats[i]
                
                for( var i in taskcat.tasks ) {
                    var task = taskcat.tasks[i]
                    if( task.optional == false ) continue
                    total_hrs += parseFloat(task.hours)
                }
            }
            return total_hrs
        },

        getTotal: (state,getters,rootState,rootGetters) => (spec) => 
        {
            var project = rootGetters['projects/getOne'](spec.project_key)
            var hour_rate = project.hour_rate
            return getters.getHours(spec) * hour_rate
        },

        
    },// getters

}


// WEBPACK FOOTER //
// ./src/store/modules/specs.js